import { render } from "./InternalNotesDialog.vue?vue&type=template&id=18b842fe"
import script from "./InternalNotesDialog.vue?vue&type=script&lang=js"
export * from "./InternalNotesDialog.vue?vue&type=script&lang=js"

import "./InternalNotesDialog.vue?vue&type=style&index=0&id=18b842fe&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__